import { render, staticRenderFns } from "./tambahDataLahan.vue?vue&type=template&id=3b90af2c"
import script from "./tambahDataLahan.vue?vue&type=script&lang=js"
export * from "./tambahDataLahan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports